import { Banners } from "@faire/retailer-visitor-shared/components/Banners/Banners";
import { useSearchPageBannersData } from "@faire/retailer-visitor-shared/components/Banners/DataFetching/useSearchPageBannersData";
import { SearchResultsBanner } from "@faire/retailer-visitor-shared/components/Banners/SearchBanners/SearchResultsBanner";
import { SignUpProductGridBanner } from "@faire/retailer-visitor-shared/components/SignUpProductGridBanner/SignUpProductGridBanner";
import { IBannerData } from "@faire/retailer-visitor-shared/lib/bannerUtils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useDiscoverPageFilteredProductGrids } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useDiscoverPageFilteredProductGrids";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useDiscoverPageShouldShowTopProducts } from "@faire/retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { RenderWithBuilder } from "@faire/web--source/builder/BuilderComponents/RenderWithBuilder";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useAssignSettingBuilderXp1WithBooleanType } from "@faire/web--source/common/settings/useSettingBuilderExperiments";
import React, { useCallback } from "react";

interface IProps {
  banners: IBannerData<SearchResultsBanner>[];
}

export const SearchBanners: React.FC<IProps> = ({ banners }) => {
  const { bannersResponse } = useSearchPageBannersData();

  const isDiscoverPage = useSearchPageIsFromDiscoverURL();

  const filteredProductGrids = useDiscoverPageFilteredProductGrids();
  const shouldShowDiscoverTopProducts = useDiscoverPageShouldShowTopProducts();
  const shouldRenderSignUpProductGridBanner =
    !isDiscoverPage ||
    (filteredProductGrids.length === 0 && !shouldShowDiscoverTopProducts);
  const assignSettingBuilderXp1WithBooleanType =
    useAssignSettingBuilderXp1WithBooleanType();
  const renderBanner = useCallback(
    (banner: IBannerData<SearchResultsBanner>) => {
      switch (banner.type) {
        case SearchResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER:
          if (
            bannersResponse?.sign_up_product_grid_banner &&
            shouldRenderSignUpProductGridBanner
          ) {
            if (isDiscoverPage) {
              return (
                <RenderWithBuilder
                  modelName="discover-sign-up-banner"
                  data={{
                    signupUrl: `${getWindow()?.location}?signUp=1`,
                  }}
                  onViewEvent={assignSettingBuilderXp1WithBooleanType}
                />
              );
            } else {
              return (
                <SignUpProductGridBanner
                  info={bannersResponse.sign_up_product_grid_banner}
                />
              );
            }
          } else {
            return null;
          }
        default:
          return null;
      }
    },
    [bannersResponse, isDiscoverPage, shouldRenderSignUpProductGridBanner]
  );

  return (
    <Banners
      renderBanner={renderBanner}
      banners={banners}
      name="search-inline-element"
    />
  );
};
